import React from 'react';

const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-US'));
const pct = (v) => (v == null ? '—' : `${Math.round(Number(v) * 100)}%`);
// x of y as "25% · 3/12"; y=0 (nothing due yet) has no defined percentage.
const ratio = (x, y) => {
  const xs = Number(x ?? 0);
  const ys = Number(y ?? 0);
  return ys > 0 ? `${pct(xs / ys)} · ${xs}/${ys}` : '— · 0/0';
};

export function ReportsSummaryCards({ summary, loading }) {
  if (loading) return <p className="loading-msg">Loading summary…</p>;
  const s = summary || {};
  const cards = [
    { label: 'Submitted', value: num(s.submitted_count) },
    { label: 'Past due', value: ratio(s.past_due_count, s.due_count) },
    { label: 'Approved', value: num(s.approved_count) },
    { label: 'Rejected', value: num(s.rejected_count) },
    { label: 'Approval ratio', value: pct(s.approval_ratio) },
  ];
  return (
    <div className="summary-cards">
      {cards.map((c) => (
        <div className="summary-card" key={c.label}>
          <div className="value">{c.value}</div>
          <div className="label">{c.label}</div>
        </div>
      ))}
    </div>
  );
}
